import ProgressBar from '@r1-frontend/ui-react/components/SolidProgressBar';
import { SingleArrowLeft } from '@r1-frontend/ui-react/components/svg/arrows';
import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

export interface IProps {
    progress: number,
    title: string,
    imgPath?: string,
    imgName?: string,
    onClick?: () => void,
    Icon?: (props: TSvgProps) => JSX.Element,
    onClickInfoIcon?: () => void,
}


export const STEPPABLE_PROGRESS_BAR_ID = 'SteppableProgressBar';

/**
 * Прогресс бар с кнопкой Назад и картинкой
 */
export const SteppableProgressBar = ({ progress, title, imgPath, imgName, onClick, Icon, onClickInfoIcon }: IProps) => {
    return (
        <ST.StepProgress data-test={STEPPABLE_PROGRESS_BAR_ID}>
            <ST.HeaderWrap>
                {onClick &&
                    <ST.Btn
                        data-test={`${STEPPABLE_PROGRESS_BAR_ID}__back-btn`}
                        onClick={onClick}
                        size='small'
                        bType='ghost'
                        Icon={<SingleArrowLeft size={20}/>}
                    />
                }

                <Paragraph4 $smaller={true}>{title}</Paragraph4>

                {imgName && imgPath &&
                    <ST.ImgWrap data-test={`${STEPPABLE_PROGRESS_BAR_ID}__progress-image`}>
                        <img src={`${imgPath}/${imgName}`} alt='картинка прогресса'/>
                    </ST.ImgWrap>
                }
                {!imgName &&
                    <ControlElement Icon={Icon} onClick={onClickInfoIcon}/>
                }
            </ST.HeaderWrap>
            <ProgressBar
                color={COLORS.Outline_Dark}
                background={COLORS.BgSurface}
                width={4}
                borderRadius={50}
                progress={progress}
            />
        </ST.StepProgress>
    );
};

export default SteppableProgressBar;
